/// <amd-module name="SuiteCommerce.FeaturedCategory.FeaturedCategory"/>
define("SuiteCommerce.FeaturedCategory.FeaturedCategory", ["require", "exports", "SuiteCommerce.FeaturedCategory.View"], function (require, exports, FeaturedCategory_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FeaturedCategoryModuleCCT = {
        mountToApp: function (container) {
            this.registerCCT(container);
        },
        registerCCT: function (container) {
            var cmsComponent = container.getComponent('CMS');
            cmsComponent.registerCustomContentType({
                id: 'cct_netsuite_featuredcategorycct',
                view: FeaturedCategory_View_1.FeaturedCategoryView,
                options: {
                    container: container,
                },
            });
        },
    };
});
